import { Divider, Form, Input, Button } from 'antd';

const PersonalizePortfolioForm = ({ onSubmit,  }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    onSubmit(values);
  };

  return (
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
      >
        <Form.Item
          label="Clients Name"
          name="clientName"
          rules={[{ required: true, message: 'Please enter your name' }]}
        >
          <Input placeholder="Enter your name" />
        </Form.Item>

        <Form.Item
          label="Risk Score"
          name="riskScore"
          rules={[{ required: true, message: 'Please enter your risk score' }]}
        >
          <Input placeholder="Enter your risk score" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
  );
};

export default PersonalizePortfolioForm;